import { render, staticRenderFns } from "./ExpenseTable.vue?vue&type=template&id=85351822&"
import script from "./ExpenseTable.vue?vue&type=script&lang=js&"
export * from "./ExpenseTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
